var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"formOrgReference",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-text-field',{attrs:{"label":"Kontaktperson","rules":[_vm.orgReferenceRule]},model:{value:(_vm.orgReference),callback:function ($$v) {_vm.orgReference=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"orgReference"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }